/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditListResponse {
    getFixupPrototypeFunction() { return RequestAuditListResponse.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditListResponse>): RequestAuditListResponse {
        let obj = Object.assign(new RequestAuditListResponse(), model);
        RequestAuditListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditListResponse>): RequestAuditListResponse {
        if (!model) return null;
        return RequestAuditListResponse.newInstance(<RequestAuditListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditListResponse) {
        if (!obj) return;

        models.RequestAuditListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditListResponse): boolean {
        Object.setPrototypeOf(obj, RequestAuditListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
